import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeleteChatDialogProps {
  confirmChatDelete: boolean;
  setConfirmChatDelete: (show: boolean) => void;
  confirmDeleteChat: () => void;
}

const DeleteChatDialog: React.FC<DeleteChatDialogProps> = ({
  confirmChatDelete,
  setConfirmChatDelete,
  confirmDeleteChat,
}) => {
  return (
    <AlertDialog open={confirmChatDelete} onOpenChange={setConfirmChatDelete}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Conversation</AlertDialogTitle>
          <AlertDialogDescription>
            Jeni i sigurt që doni të fshini këtë bisedë të tërë? Të gjitha
            mesazhet do të fshihen përgjithmonë. Ky veprim nuk mund të zhbëhet.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={confirmDeleteChat}
            className="bg-red-500 hover:bg-red-600 text-white"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteChatDialog;
